import styled from 'styled-components'
import Colors from '../../aids/Colors'

const { mainColor, experienceColor, navColor } = Colors

export const ContactSection = styled.div`
    background-color: ${navColor}
`;


export const Div = styled.div`
    background-color: ${experienceColor}
`;

export const Icon = styled.i`
color: ${mainColor}
`;
